import * as React from "react";
import { Button, Modal } from "antd";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { useContext, useState } from "react";
import { ServiceContext } from "src/services/provider/Service.provider";
import { CopyTextInput } from 'src/components/common/CopyTextInput/CopyTextInput';
import { formatDateTime } from 'src/util/Date.helper';
import ICredDefense from 'src/services/interfaces/prefraud/credDefense/ICredDefense';
import IGenericButtons from 'src/components/common/GenericButtons/Interfaces/IGenericButtons';
import { CredDefenseStatusEnum } from 'src/services/Enum/credDefense/CredDefenseStatusEnum';
interface IReprocessPreFraudButtonProps extends IGenericButtons {
  currentTradeId: number;
  onReprocessFinished: (currentCredDefense: ICredDefense) => void
}

export const ReprocessPreFraudButton: React.FC<IReprocessPreFraudButtonProps> = ({
  setLoading,
  currentTradeId,
  onReprocessFinished,
}) => {

  const { fraudService } = useContext(ServiceContext);

  //#region Success Modal  
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [currentCredDefense, setCurrentCredDefense] = useState<ICredDefense>(null);
  //#endregion

  function onOkModalClick() {
    setLoading(true);
    fraudService
      .reprocessPreFraud(currentTradeId, false)
      .then((resp) => {
        setCurrentCredDefense(resp);
        onReprocessFinished(resp);
        ShowNotification.Success("Sucesso", "O processo de Pré Fraude será reprocessado")
      })
      .catch(e => ShowNotification.Error("Erro ao reprocessar a análise de Fraude", e))
      .finally(() => setLoading(false));
  }

  function onSuccessModalClosed() {
    setCurrentCredDefense(null);
    setShowSuccessModal(false);
  }


  return (
    <>
      <Button
        icon="reload"
        onClick={onOkModalClick}
        style={
          { backgroundColor: "rgb(201, 225, 255)", color: "#151524" }
        }
      >
        Reprocessar Análise de Pré Fraude
      </Button>

      <Modal className="modal-mid"
        title={
          currentCredDefense?.status === CredDefenseStatusEnum.AWAITING ? "Link de selfie gerado com sucesso" : "Não é necessario capturar Selfie"
        } visible={showSuccessModal} onOk={onSuccessModalClosed} onCancel={onSuccessModalClosed}>
        {currentCredDefense?.status === CredDefenseStatusEnum.SHOULD_NOT_RUN && (
          <div>
            <p>Não é necessário realizar a captura da selfie pois o cedente é do tipo PJ</p>
          </div>
        )}

        {currentCredDefense?.status === CredDefenseStatusEnum.AWAITING && (
          <div>
            <p>{`O link foi gerado em ${formatDateTime(currentCredDefense?.requestDate)} e tem validade de 48 horas.`}</p>
            <CopyTextInput value={currentCredDefense?.selfieUrl} />
          </div>
        )}
      </Modal>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/PreFraudView/ReprocessPreFraudButton.tsx